import queryString from 'qs';

import { removeDoubleSlashes, removeTrailingSlash, addTrailingSlash as addSlash } from './string';

const dropQuery = url => url.split('?')[0];

export const getPath = (url = '') => /(^|\/)[^.]*($|\/$)/.exec(dropQuery(url))[0] || '';

export const getSlug = (url = '') => /(^|\/)[^/]*($|\/$)/.exec(dropQuery(url))[0] || '';

export const createUrl = (baseURL = '', { pathname = '', search = '', hash = '' }) => (
  `${removeTrailingSlash(baseURL)}${removeDoubleSlashes(`${pathname}${search}${hash ? `#${hash}` : ''}`)}`
);

const intersectSlash = (_, s1, s2) => `${s1}/${s2}`;
export const addTrailingSlash = (url = '') => {
  if (url.includes('#')) return url.replace(/([^/])([#])/, intersectSlash);
  if (url.includes('?')) return url.replace(/([^/])([?])/, intersectSlash);
  return addSlash(url);
};

export const getQueryObject = (queryStr = '') =>
  queryString.parse((queryStr.charAt(0) === '?') ? queryStr.substring(1) : queryStr);

export const getQueryString = (query = {}) => queryString.stringify(query);



// WEBPACK FOOTER //
// ./src/universal/ui/utils/url.js